export default function() {
	document.querySelectorAll('form[data-newsletter-simple]').forEach((form) => {
		const emailEl   = form.querySelector('#newsletter-strip-email');
		const nameEl    = form.querySelector('#newsletter-strip-name');
		const consentEl = form.querySelector('#newsletter-consent');
		const submitBtn = form.querySelector('button[type="submit"]');
		let msgEl       = form.querySelector('#newsletter-strip-error');

		// Create message node if missing
		if (!msgEl) {
			msgEl = document.createElement('div');
			msgEl.id = 'newsletter-strip-error';
			form.appendChild(msgEl);
		}

		const showMsg = (html, ok = false) => {
			msgEl.innerHTML = html || '';
			msgEl.classList.toggle('form-valid', !!ok);
			msgEl.classList.toggle('form-errors', !ok);

			// If inside accordion, re-measure height so message shows
			const pane = msgEl.closest('.site-accordion__content[aria-hidden="false"]');
			if (pane) {
				pane.style.maxHeight = 'none';
				pane.style.maxHeight = pane.scrollHeight + 'px';
			}
		};

		const setBusy = (b) => {
			if (!submitBtn) return;
			const label = submitBtn.getAttribute('data-label') || submitBtn.textContent || 'Submit';
			submitBtn.disabled = !!b;
			submitBtn.textContent = b ? 'Submitting…' : label;
		};

		form.addEventListener('submit', async (e) => {
			e.preventDefault();
			showMsg('');

			// ----- Validation -----
			const email = (emailEl?.value || '').trim();
			const first = (nameEl?.value || '').trim();
			const accepted = !!(consentEl && consentEl.checked);

			if (!/.+@.+\..+/.test(email)) {
				showMsg("<p class='white'>Please enter a valid email address.</p>");
				emailEl?.focus();
				return; // ⛔️ stop here — no “Submitting…” yet
			}

			if (!accepted) {
				showMsg("<p class='white'>Please tick the consent box.</p>");
				consentEl?.focus();
				return; // ⛔️ stop here
			}

			// ----- Passed validation → safe to show busy state -----
			setBusy(true);

			const payload = {
				email,
				first_name: first,
				accept_terms: true,
				newsletterType: 'static',
				opt_london_theatre_guide: true,
			};

			try {
				const res = await fetch('/wp-json/subscribers/all', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					credentials: 'same-origin',
					cache: 'no-store',
					body: JSON.stringify(payload),
				});

				if (res.ok) {
					form.innerHTML = "<h3 class='white'>Thank you for signing up.</h3>";
				} else {
					const body = await res.json().catch(() => ({}));
					const msg = body?.error ? String(body.error).replace(/</g, '&lt;') : 'Please try again.';
					showMsg(`<p class='white'>Sorry, we weren’t able to subscribe you. ${msg}</p>`);
					setBusy(false);
				}
			} catch {
				showMsg("<p class='white'>Network error. Please try again.</p>");
				setBusy(false);
			}
		});
	});
}
